// @NOTE: scss와 jsx가 분리되어 있어 scss 변수를 가져올 수 없음. jsx에 쓸 변수 따로 선언

export const PROFILE_SIZE = '40px';
